module.exports = __webpack_public_path__ + "img/mac2.798c7c25.png";